import { render, staticRenderFns } from "./IdentityCard.vue?vue&type=template&id=5398a1e9&scoped=true"
import script from "./IdentityCard.vue?vue&type=script&lang=js"
export * from "./IdentityCard.vue?vue&type=script&lang=js"
import style0 from "./IdentityCard.vue?vue&type=style&index=0&id=5398a1e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5398a1e9",
  null
  
)

export default component.exports